import { CoreAPI, createAPIMethod, createCommonPaymentMethods } from '@hero/sdk-core';
import { InvoiceUploadProofCarrierAPI } from '@hero/api';

export function createPaymentAPI(coreAPI: CoreAPI) {
  return {
    ...createCommonPaymentMethods(coreAPI),

    /**
     * Upload invoice proof as a carrier
     *
     * API: {@link InvoiceUploadProofCarrierAPI}
     */
    carrierUploadInvoiceProof: createAPIMethod<InvoiceUploadProofCarrierAPI>(
      coreAPI,
      'payment.carrierUploadInvoiceProof',
    ),
  };
}
